import { Component } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle'; // import it to your component
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { DialogwithtimerComponent } from './Shared/dialogwithtimer/dialogwithtimer.component';
import { LocalService } from './local.service';
import { timer } from 'rxjs';
import { LogoutService } from './logout/logout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  postresult: boolean;
  title = 'app';
  dialogRes: boolean=false;
  timeLeft: number;
  interval;
  subscribeTimer: any;
  isPopupExists=false;
  constructor(
    private toastr: ToastrService,
    private router: Router ,
    private bnIdle: BnNgIdleService,
    private dialogService: DialogService, 
    private localService: LocalService,
    private logoutservice: LogoutService
    ) { // initiate it in your component constructor
      
      this.bnIdle.startWatching(1200).subscribe((res) => {
        if(res) {
          //console.log(router.url);  
          //console.log("session expired");
          
          this.dialogRes=false;
          this.timeLeft=120;
          

          if(router.url !='/')
          {
            //this.bnIdle.stopTimer();
            //this.startTimer();
            if(this.isPopupExists!=true){
            let showpopup = this.dialogService.addDialog(DialogwithtimerComponent,
            {
              
              title: 'Please Confirm',
            //  message: 'Your session is about to expire. You will be logged out in'+ this.timeLeft +' seconds.',
              hclass: 'modelsuccess',
              oktext: 'Continue Session',
              canceltext: 'Log Out',
              okshow: true,
              cancelshow: true
            }).subscribe((isConfirmed) => {
              
              if (isConfirmed) {
                this.dialogRes=true;
                this.isPopupExists=false;
                //this.bnIdle.stopTimer();
                console.log("session started again");
              }
              else {
                this.logout();
              }
            });
            this.isPopupExists=true;   
          }
         }
      }
    }) 
  }

  logout()
  {
    this.isPopupExists=false;
    if (localStorage.getItem("LoggedIn") == null || localStorage.getItem("LoggedIn") == undefined) {
      localStorage.clear();
      
      // Clear the localStorage
      this.localService.clearToken();

      this.router.navigate(["login"]);
    }
    else {  
      var logid = this.localService.getJsonValue("logid");
                var returnedid = this.logoutservice.logout(logid).subscribe(res => {
                  //console.log(res);
                  if (res.status == 200) {
                    this.postresult = true;
                    localStorage.clear();
            
                    // Clear the localStorage
                    this.localService.clearToken();
            
                    localStorage.removeItem("LoggedIn");
                    this.router.navigate(["login"]);
                  };
            
                },
                  error => {
                    this.toastr.error(error.error);
                    this.postresult = false
                  })
                }
  }
 /* oberserableTimer() {
    const source = timer(1000, 1000);
    const abc = source.subscribe(val => {
      //console.log(val, '-');
      this.subscribeTimer = this.timeLeft - val;
      console.log(this.subscribeTimer);
      if(this.subscribeTimer <= 0) {
        abc.unsubscribe();
        
        // Clear the localStorage
        localStorage.clear();
        this.localService.clearToken();
        localStorage.removeItem("LoggedIn");

        this.router.navigate(["login"]);
      }
    });
  }*/
  
  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } 
      console.log(this.timeLeft);
    },1000)
  }
}
